import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './JdAi.css';
import Navbar from '../About/Navbar';
import Footer from '../About/Footer';

function JdAi() {
  const navigate = useNavigate();
  const [prompt, setPrompt] = useState('');
  const [isGenerating, setIsGenerating] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!prompt.trim()) {
      setError('Please enter a prompt to generate job description');
      return;
    }

    setIsGenerating(true);
    setError('');

    try {
      console.log('Starting JD generation with prompt:', prompt);
      
      // Call the AI API
      const response = await fetch('/api/generate_jd_ai', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ prompt })
      });

      console.log('Response status:', response.status);
      console.log('Response headers:', response.headers);

      if (!response.ok) {
        const errorText = await response.text();
        console.error('API Error:', response.status, errorText);
        throw new Error(`Failed to generate job description: ${response.status}`);
      }

      const data = await response.json();
      console.log('Response data:', data);
      
      const generatedJdData = data.job_details;
      console.log('Generated JD data:', generatedJdData);
      
      // Store the generated data in localStorage and navigate to JD creation page
      localStorage.setItem('generatedJdData', JSON.stringify(generatedJdData));
      console.log('Stored data in localStorage');
      
      setIsGenerating(false);
      console.log('Navigating to /jd');
      navigate('/jd');
    } catch (error) {
      console.error('JD Generation Error:', error);
      setError('Failed to generate job description. Please try again.');
      setIsGenerating(false);
    }
  };



  return (
    <div className="page-container">
      <Navbar />
      <div className="jd-ai-container-2">
        <div className="jd-ai-content-2">
          <div className="jd-ai-header">
            <h1>Generate Job Description with AI</h1>
            {/* <p>Enter a detailed prompt describing the job position you want to create. Our AI will generate a comprehensive job description for you.</p> */}
          </div>

          <form onSubmit={handleSubmit} className="jd-ai-form">
            <div className="form-group">
              <label htmlFor="prompt">Tell Us About the Job You're Hiring For:</label>
              <textarea
                id="prompt"
                value={prompt}
                onChange={(e) => setPrompt(e.target.value)}
                placeholder="Describe the job position you want to create. For example: 'We need a senior frontend developer with React experience for a remote position. The role involves building user interfaces and collaborating with design teams.'"
                rows="6"
                className="prompt-textarea"
                disabled={isGenerating}
              />
            </div>

            {error && <div className="error-message">{error}</div>}

            <div className="form-actions">
              <button
                type="submit"
                className="generate-btn"
                disabled={isGenerating || !prompt.trim()}
              >
                {isGenerating ? (
                  <>
                    <div className="loading-spinner"></div>
                    Generating Job Description...
                  </>
                ) : (
                  'Generate Job Description'
                )}
              </button>
            </div>
          </form>

          {isGenerating && (
            <div className="generation-status">
              <div className="status-content">
                <div className="loading-spinner large"></div>
                <h3>Generating your job description...</h3>
                <p>This may take a few moments. Please wait while our AI creates a comprehensive job description based on your requirements.</p>
              </div>
            </div>
          )}

          <div className="tips-section">
            <h3>📌 Write Smarter, Get Better Results:</h3>
            <ul>
              <li>Include the job title and level (junior, senior, etc.)</li>
              <li>Mention required skills and technologies</li>
              <li>Specify work arrangement (remote, hybrid, office)</li>
              <li>Include experience level and salary expectations</li>
              <li>Describe the company culture and work environment</li>
            </ul>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default JdAi;